import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import { AccountCircle as AccountCircleIcon } from '@mui/icons-material';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import { AUTH_ENABLED } from '../authConfig';

/**
 * AUTH-4 — auth affordances for the nav bar. Renders nothing when
 * REACT_APP_AUTH_ENABLED is off; otherwise a "Sign in" link for signed-out users
 * and Clerk's <UserButton/> for signed-in users. Must render inside <ClerkProvider>
 * (AuthProvider), which is guaranteed whenever AUTH_ENABLED is on.
 */
export default function AuthControls() {
    if (!AUTH_ENABLED) {
        return null;
    }

    return (
        <>
            <SignedOut>
                <Button
                    component={RouterLink}
                    to="/sign-in"
                    size="small"
                    startIcon={<AccountCircleIcon sx={{ fontSize: 18 }} />}
                    sx={{
                        color: 'rgba(255,255,255,0.75)',
                        fontSize: '0.8rem',
                        textTransform: 'none',
                        borderRadius: 1,
                        px: 1.5,
                        '&:hover': { color: '#90caf9', backgroundColor: 'rgba(144,202,249,0.06)' },
                    }}
                >
                    Sign in
                </Button>
            </SignedOut>
            <SignedIn>
                <UserButton afterSignOutUrl="/" />
            </SignedIn>
        </>
    );
}
